<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction: Why Pastors Need a Rule</a></div>
<div class="SOM_chap_autre"><a href="#/chap1"><span class="mev2">1</span> The Grace of Theological Friendships: Augustine</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev2">2</span> “The Work of Obedience”: Benedict</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev2">3</span> The Holiness That Stoops to Serve: Gregory the Great</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev2">4</span> “All the Ministers Shall Meet Together”: John Calvin</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev2">5</span> Choosing Your Words Carefully: John Wesley</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev2">6</span> The Pastor’s Study: John Henry Newman</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev2">7</span> The Gift of Physical Presence: Dietrich Bonhoeffer</span></div>
<div class="SOM_chap_autre2"><span href="#/chap8" title="Link target outside of Sample"><span class="mev2">8</span> A Contemporary Pastoral Rule</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Conclusion: Developing and Practicing a Pastoral Rule</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Praise for <i>A Pastoral Rule for Today</i></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?f8896ea6